import { AlertModal, Button, Modal, TextBlock } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import { ImportedAssetsSubpage } from "components/asset-management-system/upload/ImportedAssetsSubpage";
import { UploadAssetsBehavior } from "components/asset-management-system/upload/UploadAssetsBehavior";
import { subpageContext } from "components/layout/ApplicationLayout";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    groupUuid?: string;
}

export const UploadAssetsModal = (props: Props) => {
    const { t } = useTranslation();
    const context = React.useContext(subpageContext);
    const [succeeded, setSucceeded] = React.useState(false);
    const [done, setDone] = React.useState(false);
    const [modalVisibility, setModalVisibility] = React.useState(false);
    const [totalAssets, setTotalAssets] = React.useState(0);

    React.useEffect(() => {
        context?.setSubpage({ content: undefined });
        if (done) {
            setModalVisibility(true);
        }
        setDone(false);
    }, [done]);

    function submitFile(assets: Record<string, string>[], file: File) {
        props.onClose();
        const headers = Object.keys(assets[0]);
        const rows = assets.map((asset) => headers.map((header) => asset[header]));
        setTotalAssets(rows.length);

        context?.setSubpage({
            content: (
                <ImportedAssetsSubpage
                    headers={headers}
                    rows={rows}
                    file={file}
                    groupUuid={props.groupUuid}
                    onDone={(withSuccess: boolean) => {
                        setDone(true);
                        setSucceeded(withSuccess);
                    }}
                />
            ),
            isModal: true,
        });
    }

    return (
        <>
            <Modal
                isOpen={props.isOpen}
                hideModal={() => props.onClose()}
                title={t("AssetManagement.upload.fileUploadModal.title")}
            >
                <UploadAssetsBehavior onViewAssets={submitFile} />
            </Modal>
            {succeeded ? (
                <Modal
                    isOpen={modalVisibility}
                    hideModal={() => setModalVisibility(false)}
                    title={t("AssetManagement.upload.uploadSubmitted.started.title")}
                >
                    <TextBlock>
                        {t("AssetManagement.upload.uploadSubmitted.started.message", {
                            numberOfAssets: totalAssets,
                        })}
                    </TextBlock>
                </Modal>
            ) : (
                <AlertModal
                    title={t("AssetManagement.upload.uploadSubmitted.alert.title")}
                    variant={"Error"}
                    isOpen={modalVisibility}
                    hideModal={() => setModalVisibility(false)}
                    buttons={
                        <Button onClick={() => setModalVisibility(false)} variant={"Primary"}>
                            Close
                        </Button>
                    }
                >
                    <TextBlock>{t("AssetManagement.upload.uploadSubmitted.alert.message")}</TextBlock>
                </AlertModal>
            )}
        </>
    );
};
